/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filtry`
};

const da_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filtre`
};

const de_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filter`
};

const en_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filters`
};

const es_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filtros`
};

const fr_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filtres`
};

const hu_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Szűrők`
};

const it_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filtri`
};

const nl_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filters`
};

const pl_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filtry`
};

const pt_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filtros`
};

const sv_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const filters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.filters(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("filters", locale)
	if (locale === "cs") return cs_filters(inputs)
	if (locale === "da") return da_filters(inputs)
	if (locale === "de") return de_filters(inputs)
	if (locale === "en") return en_filters(inputs)
	if (locale === "es") return es_filters(inputs)
	if (locale === "fr") return fr_filters(inputs)
	if (locale === "hu") return hu_filters(inputs)
	if (locale === "it") return it_filters(inputs)
	if (locale === "nl") return nl_filters(inputs)
	if (locale === "pl") return pl_filters(inputs)
	if (locale === "pt") return pt_filters(inputs)
	return sv_filters(inputs)
};